import { useAppStateContext } from '../../hooks/useAppState';

// This component is exactly what it is named as, sorry I dont know how to really comment this one
export default function MPISelectionTable() {
  const { state, updateMpiData } = useAppStateContext();
  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <h3 className="text-md font-semibold mb-2">Current MPI Data:</h3>
      {state.mpiData.length === 0 ? (
        <p className="text-sm text-gray-500">No MPI data available. Run analyses in Water Quality or Hydrology tabs to populate this data.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm border border-gray-200 rounded">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-3 py-2 border">Analyte</th>
                <th className="px-3 py-2 border">Priority</th>
                <th className="px-3 py-2 border">Threshold</th>
                <th className="px-3 py-2 border">Index Score</th>
                <th className="px-3 py-2 border">Weight</th>
              </tr>
            </thead>
            <tbody>
              {state.mpiData.map((data) => (
                <tr key={data.analytename} className="bg-white">
                  <td className="px-3 py-2 border font-medium text-blue-600">{data.analytename}</td>
                  <td className="px-3 py-2 border">
                      <select className="w-full" value={data.priority} onChange={(e) => updateMpiData(state.mpiData.map(d => d.analytename === data.analytename ? { ...d, priority: parseInt(e.target.value) } : d))}>
                          <option value="1">High</option>
                          <option value="3">Medium</option>
                          <option value="7">Low</option>
                          <option value="9001">Not Interested</option>
                      </select>
                  </td>
                  <td className="px-3 py-2 border">{data.threshold !== undefined ? data.threshold : 'N/A'}</td>
                  <td className="px-3 py-2 border">{data.score !== null && data.score !== undefined ? data.score.toFixed(3) : 'N/A'}</td>
                  <td className="px-3 py-2 border">{data.weight !== null && data.weight !== undefined ? data.weight.toFixed(3) : 'Not calculated'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
} 